import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, InputNumber, DatePicker, Icon, notification, Checkbox, Radio, Divider } from "antd";
import axios from "axios";
import moment from "moment";
import SectionCard from "../../components/SectionCard";
import SectionDivider from "../../components/SectionDivider";

const { TextArea } = Input;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message,
        description
    });
};

const parseObject = (value, fallback = {}) => {
    if (!value) return fallback;
    if (typeof value === "object" && !Array.isArray(value)) return value;
    try {
        const parsed = JSON.parse(value);
        return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : fallback;
    } catch {
        return fallback;
    }
};

const DrawerAdicionarEstudoAEE = ({ id, pastaId, visible, atualizarListagem, onClose, form }) => {
    const estadoInicial = {
        id: undefined,
        id_disciplina: undefined,
        data_realizacao: moment(),
        descricao: "",
        tecnicas_utilizadas: "",
        nome_crianca: "",
        ano_serie: "",
        turma: "",
        turno: "",
        idade: null,
        professor: "",
        data_nascimento: moment(),
        recomendacoes_finais: ""
    };

    const [registo, setRegisto] = useState(estadoInicial);
    const [isLoading, setIsLoading] = useState(false);

    const { getFieldDecorator, getFieldValue } = form;

    const handleSubmit = e => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (!err) {
                if (id) {
                    alterarEstudo(values);
                } else {
                    adicionarEstudo(values);
                }
            }
        });
    };

    const carregarDetalhe = id => {
        setIsLoading(true);
        axios({
            method: "get",
            url: "/api/estudo-caso/carregar-estudo-aee",
            params: { id }
        })
            .then(response => {
                const dados = response.data;

                const turmaInfo = parseObject(dados.turma_ano, {
                    ano_serie: "",
                    turma: "",
                    turno: ""
                });

                const registoTratado = {
                    ...dados,
                    ano_serie: turmaInfo.ano_serie || "",
                    turma: turmaInfo.turma || "",
                    turno: turmaInfo.turno || "",
                    data_nascimento: dados.data_nascimento ? moment(dados.data_nascimento) : moment(),
                    recomendacoes_finais: dados.recomendacoes_finais || ""
                };

                setRegisto(registoTratado);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Ocorreu um erro ao carregar o detalhe.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const adicionarEstudo = values => {
        setIsLoading(true);

        const estudo = {
            id_disciplina: localStorage.getItem("codigo_curso"),
            tipo: "estudo_caso_aee",
            nome_crianca: values.nome_crianca,
            turma_ano: JSON.stringify({
                ano_serie: values.ano_serie || "",
                turma: values.turma || "",
                turno: values.turno || ""
            }),
            idade: values.idade,
            professor: values.professor,
            data_nascimento: values.data_nascimento ? values.data_nascimento.format("YYYY-MM-DD") : null,
            recomendacoes_finais: values.recomendacoes_finais
        };

        axios({
            method: "post",
            url: "/api/estudo-caso/adicionar-plano-estudo-aee",
            data: estudo
        })
            .then(response => {
                openNotificationWithIcon("success", "Sucesso", "Estudo de caso criado com sucesso.");
                atualizarListagem(response.data);
                handleClose();
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Erro ao criar o estudo.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const alterarEstudo = values => {
        setIsLoading(true);

        const estudo = {
            id: id,
            nome_crianca: values.nome_crianca,
            turma_ano: JSON.stringify({
                ano_serie: values.ano_serie || "",
                turma: values.turma || "",
                turno: values.turno || ""
            }),
            idade: values.idade,
            professor: values.professor,
            data_nascimento: values.data_nascimento ? values.data_nascimento.format("YYYY-MM-DD") : null,
            recomendacoes_finais: values.recomendacoes_finais
        };

        axios({
            method: "put",
            url: "/api/estudo-caso/alterar-plano-estudo-aee",
            data: estudo
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Estudo de caso alterado com sucesso.");
                atualizarListagem();
                handleClose();
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Ocorreu um erro ao alterar o estudo de caso.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const carregarDadosAluno = () => {
        axios({
            method: "get",
            url: "/api/estudo-caso/carregar-informacoes",
            params: {
                pastaId,
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                const { aluno, turma } = response.data;
                setRegisto(prevState => ({
                    ...prevState,
                    nome_crianca: aluno?.nome ?? prevState.nome_crianca,
                    ano_serie: turma?.ano_serie ?? prevState.ano_serie,
                    turma: turma?.nome ?? prevState.turma,
                    turno: turma?.turno ?? prevState.turno,
                    idade: aluno?.idade ?? prevState.idade,
                    professor: turma?.professor ?? prevState.professor
                }));
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao carregar dados.");
            });
    };

    const carregarDadosAlunoEnsinoEspecial = () => {
        axios({
            method: "get",
            url: "/api/estudo-caso/carregar-informacoes-ensino-especial",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                const { aluno, turma } = response.data;

                setRegisto(prevState => ({
                    ...prevState,
                    nome_crianca: aluno?.nome ?? prevState.nome_crianca,
                    ano_serie: turma?.ano_serie ?? prevState.ano_serie,
                    turma: turma?.nome ?? prevState.turma,
                    turno: turma?.turno ?? prevState.turno,
                    idade: aluno?.idade ?? prevState.idade,
                    professor: turma?.professor ?? prevState.professor
                }));
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao carregar dados.");
            });
    };

    const handleClose = () => {
        onClose();
        limparCampos();
    };

    const afterVisibleChange = aberto => {
        if (!aberto && id === null) {
            limparCampos();
        }
    };

    const limparCampos = () => {
        form.resetFields();
        setRegisto(estadoInicial);
    };

    useEffect(() => {
        if (visible && id) {
            carregarDetalhe(id);
        }
        
        if (pastaId && visible) {
            carregarDadosAluno(); // corre também na edição
        }

        if (visible && !id && !pastaId) {
            carregarDadosAlunoEnsinoEspecial();
        }
    }, [id, visible]);

    return (
        <Drawer
            className="drawer-adicionar-evento drawer-add-cursos"
            width={720}
            onClose={handleClose}
            visible={visible}
            style={{
                overflow: "auto",
                height: "calc(100% - 108px)",
                paddingBottom: "108px"
            }}
            maskClosable={false}
            afterVisibleChange={afterVisibleChange}
        >
            <div className="bloco-info">
                <Form className="form-categorias" layout="horizontal" onSubmit={handleSubmit}>
                    <SectionCard title="1. Dados da criança">
                        <Form.Item label="Nome da criança">
                            {getFieldDecorator("nome_crianca", {
                                initialValue: registo.nome_crianca,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>
                        <Form.Item label="Ano/Série">
                            {getFieldDecorator("ano_serie", {
                                initialValue: registo.ano_serie,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>
                        <Form.Item label="Turma">
                            {getFieldDecorator("turma", {
                                initialValue: registo.turma,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>
                        <Form.Item label="Turno">
                            {getFieldDecorator("turno", {
                                initialValue: registo.turno,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>
                        <Form.Item label="Idade">
                            {getFieldDecorator("idade", {
                                initialValue: registo.idade,
                                rules: [
                                    { required: true, message: "Campo obrigatório" },
                                    { type: "number", message: "Apenas números são permitidos" }
                                ]
                            })(<InputNumber min={0} precision={0} />)}
                        </Form.Item>
                        <Form.Item label="Professor(a)">
                            {getFieldDecorator("professor", {
                                initialValue: registo.professor,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>
                        <Form.Item label="Data Nascimento">
                            {getFieldDecorator("data_nascimento", {
                                initialValue: registo.data_nascimento,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<DatePicker format="DD-MM-YYYY" />)}
                        </Form.Item>
                    </SectionCard>

                    <Form.Item label="Descrição">
                        {getFieldDecorator("recomendacoes_finais", {
                            initialValue: registo.recomendacoes_finais
                        })(<TextArea rows={9} style={{ minHeight: 300 }} />)}
                    </Form.Item>

                    <div className="ant-drawer-footer">
                        <button
                            className="botao-secundario"
                            type="button"
                            onClick={handleClose}
                            style={{ marginRight: 20, display: "inline-block" }}
                        >
                            Cancelar
                        </button>
                        <button className="botao-principal" disabled={isLoading}>
                            {isLoading ? <Icon type="loading" /> : null}
                            Salvar estudo
                        </button>
                    </div>
                </Form>
            </div>
        </Drawer>
    );
};

export default Form.create({ name: "form-drawer-adicionar-estudo" })(DrawerAdicionarEstudoAEE);
